/** What the engagement did to the window on screen, in one line (Q-03, G-Wauditor-05).
 *
 * A figure screen narrows a window to an Auditor's engagement and says nothing, so a custom range
 * of Jul 2025 to Jun 2026 showed a half-year total under a twelve-month label. The arithmetic was right
 * and nothing said which months it was over - the opposite of a figure with a receipt. This is the
 * sentence the filing's Disclosures already carry, for the screens that did not.
 *
 * Two answers, from the person's own terms (`windowUnderEngagement`), and nothing about anything the
 * server withheld: **narrowed** says which part is shown, **outside** says that no part of the window
 * is something this person is engaged for - in place of a read failure and of an upload prompt to a
 * role that cannot upload. Nothing renders for a window inside the engagement.
 */

import { Link } from "@tanstack/react-router";

import { shortDate } from "../lib/format";
import type { WindowUnderEngagement } from "../lib/engagement";
import { keepSearch } from "../screens/search";
import styles from "./OutsideEngagement.module.css";

export function EngagementWindowNote({ under }: { under: WindowUnderEngagement }) {
  if (under === null) return null;
  return (
    <p className={styles.note} role="note" data-testid="engagement-window" data-kind={under.kind}>
      {under.kind === "narrowed"
        ? `Shown: ${shortDate(under.from)} to ${shortDate(under.to)}, the part of this window your engagement covers.`
        : "This window is outside your engagement, so there is nothing to show."}{" "}
      <Link to="/engagement" search={keepSearch} className={styles.link}>
        What your engagement covers
      </Link>
    </p>
  );
}
